import { action } from "satcheljs/lib/legacy";
import StringsStore from "../store";
import StringModule from '../store/schema/StringModule';

export let setStringModule = action("setStringModule")(
    function setStringModule(module: StringModule) {
        StringsStore().registeredStringModules.set(module.name, module);
    });